<div class="row nova-font-style view-adj-grid top-margin-20">
  <div class="col s12 m12 l12 xl12 remove-default-padding">
    <div *ngIf="operators && operators.View">
      <div [hidden]="initialLoading">
        <div>
          <kendo-tabstrip [animate]="true" [tabAlignment]="'justify'" #tabstrip (tabSelect)="onTabSelect($event)"
            [keepTabContent]="true">
            <kendo-tabstrip-tab [title]="tab.tabTitle" [selected]="selectedTab === i"
              *ngFor="let tab of reportsData let i=index">
              <ng-template kendoTabContent>
                <div *ngIf="tab.show" class="top-margin-10">
                  <kendo-grid [kendoGridBinding]="tab.data" id="view-report-grid" [pageSize]="state.take"
                    [resizable]="true" [skip]="state.skip" [pageable]="true" [navigable]="false" [sort]="state.sort"
                    filterable="menu" [filter]="filters" [sortable]="true" id="{{cssId}}-grid"
                    (remove)="removeHandler($event)" (edit)="editHandler($event)">
                    <ng-template kendoGridToolbarTemplate>
                      <div class="row bottom-margin-0" id="adj-mobile-view-msg">
                        <p class="text-red"><span class="k-icon k-i-warning"></span>Add/Edit adjustment will
                          not be available on Mobile Devices</p>
                      </div>
                    </ng-template>

                    <!-- MOBILE VIEW -->
                    <kendo-grid-column media="(max-width: 772.98px)" title="Details" [width]="150">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <dl>
                          <dd>
                            <div class="align-left">
                              <span class="bold">ID#: </span>
                              <span> {{ dataItem.id }}</span>
                            </div>
                          </dd>
                          <dd>
                            <div class="align-left">
                              <span class="bold">Records: </span>
                              <span> {{ dataItem.recordCount }}</span>
                            </div>
                          </dd>
                          <dd>
                            <div class="align-left">
                              <span class="bold">Contribution: </span>
                              <span [ngClass]=" 0 > dataItem.totalContributions ? 'neg-amount' : ''">
                                {{ dataItem.formatAmount }}</span>
                            </div>
                          </dd>
                          <dd>
                            <div class="align-left">
                              <span class="bold">Modified By: </span>
                              <span> {{ dataItem.createdby }}</span>
                            </div>
                          </dd>
                          <dd>
                            <div class="align-left">
                              <span class="bold">Modified Date: </span>
                              <span> {{ dataItem.createdDate | date: 'MM/dd/yyyy hh:mm a' }}</span>
                            </div>
                          </dd>
                          <dd>
                            <div class="align-left">
                              <span class="bold">Status: </span>
                              <span> {{ dataItem.status }}</span>
                            </div>
                          </dd>
                        </dl>
                      </ng-template>
                    </kendo-grid-column>

                    <!-- DETAIL VIEW -->
                    <ng-template kendoGridDetailTemplate let-dataItem *ngIf="tab.tabTitle === 'Submitted'">
                      <div>
                        <!-- DETAIL VIEW REPORT -->
                        <app-detailed-view [data]="dataItem"></app-detailed-view>
                      </div>
                    </ng-template>

                    <!-- OWNER -->
                    <kendo-grid-column field="ownerId" title="Owner" media="(min-width: 773px)" [width]="80"
                      [filterable]="false" *ngIf="tab.adjType === 'NotSubmitted' && (operators.Add || operators.Edit)">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="align-text msg-dropdown">
                          <kendo-dropdownlist [data]="ownersList" id="ownerSelect{{dataItem.Id}}"
                            [valuePrimitive]="true" [(ngModel)]="dataItem.ownerId" name="ownerSelect{{dataItem.Id}}"
                            [textField]="'fullName'" [valueField]="'id'" [filterable]="true"
                            [popupSettings]="{ popupClass: 'nova-font-style' }" (filterChange)="handleFilter($event)"
                            (selectionChange)="onOwnerSelection($event, dataItem.id)" class="full-width" required
                            ngDefaultControl>
                          </kendo-dropdownlist>
                        </div>
                      </ng-template>
                    </kendo-grid-column>

                    <!-- NORMAL VIEW -->
                    <kendo-grid-command-column title="" media="(min-width: 773px)" [width]="40"
                      *ngIf="tab.adjType === 'NotSubmitted' && (operators.Edit || operators.Delete)">
                      <ng-template kendoGridCellTemplate let-isNew="isNewUser" let-dataItem>
                        <div class="align-center" kendoTooltip>
                          <button kendoGridEditCommand id="editBtn" *ngIf="operators.Edit"
                            [disabled]="!dataItem.isAuthorizedOwner">
                            <span type="button"
                              [ngClass]="dataItem.isAuthorizedOwner ? 'link-icon' : 'link-icon-disabled'"
                              class="k-icon k-i-edit" title="Edit"></span>
                          </button>
                          <button kendoGridRemoveCommand id="removeBtn" *ngIf="operators.Delete"
                            [disabled]="!dataItem.isAuthorizedOwner">
                            <span type="button"
                              [ngClass]="dataItem.isAuthorizedOwner ? 'link-icon' : 'link-icon-disabled'"
                              class="k-icon k-i-delete" title="Delete"></span>
                          </button>
                        </div>
                      </ng-template>
                    </kendo-grid-command-column>

                    <!-- ADJUSTMENT ID -->
                    <kendo-grid-column field="id" media="(min-width: 773px)" title="ID" [width]="30"
                      [headerClass]="{'align-id': true}">
                      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                        let-filterService="filterService">
                        <kendo-grid-string-filter-menu [column]="column" [filter]="filter"
                          [filterService]="filterService" [extra]="false">
                          <kendo-filter-contains-operator></kendo-filter-contains-operator>
                        </kendo-grid-string-filter-menu>
                      </ng-template>
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="align-id">
                          <span>
                            {{dataItem.id}}
                          </span>
                        </div>
                      </ng-template>
                    </kendo-grid-column>

                    <!-- RECORDS COLUMN -->
                    <kendo-grid-column field="recordCount" media="(min-width: 773px)" title="Records" [width]="40"
                      [headerClass]="{'align-number': true}">
                      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                        let-filterService="filterService">
                        <kendo-grid-string-filter-menu [column]="column" [filter]="filter"
                          [filterService]="filterService" [extra]="false">
                          <kendo-filter-contains-operator></kendo-filter-contains-operator>
                        </kendo-grid-string-filter-menu>
                      </ng-template>
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="align-number">
                          <span>{{dataItem.recordCount}}</span>
                        </div>
                      </ng-template>
                    </kendo-grid-column>

                    <!-- TOTAL CONTRIBUTION -->
                    <kendo-grid-column field="totalContributions" media="(min-width: 773px)" title="Contribution"
                      [width]="50" [headerClass]="{'align-number': true}">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="align-number">
                          <span [ngClass]=" 0 > dataItem.totalContributions ? 'neg-amount' : ''">
                            {{dataItem.formatAmount}}
                          </span>
                        </div>
                      </ng-template>
                    </kendo-grid-column>

                    <!-- CREATED BY -->
                    <kendo-grid-column field="createdby" media="(min-width: 773px)" title="Modified By" [width]="90">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="align-text">
                          <span>
                            {{dataItem.createdby}}
                          </span>
                        </div>
                      </ng-template>
                      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                        let-filterService="filterService">
                        <kendo-grid-string-filter-menu [column]="column" [filter]="filter"
                          [filterService]="filterService" [extra]="false">
                          <kendo-filter-contains-operator></kendo-filter-contains-operator>
                        </kendo-grid-string-filter-menu>
                      </ng-template>
                    </kendo-grid-column>

                    <!-- MODIFIED DATE -->
                    <kendo-grid-column field="modifiedDate" media="(min-width: 773px)" title="Modified Date"
                      [width]="90" [headerClass]="{'align-date': true}">
                      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                        let-filterService="filterService">
                        <app-date-range-filter [field]="column.field" [filter]="filter" [filterService]="filterService">
                        </app-date-range-filter>
                      </ng-template>
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="align-date">
                          {{dataItem.modifiedDate | date: 'MM/dd/yyyy hh:mm a'}}
                        </div>
                      </ng-template>
                    </kendo-grid-column>

                    <!-- STATUS -->
                    <kendo-grid-column field="status" media="(min-width: 773px)" title="Status" [width]="60"
                      [headerClass]="{'align-left': true}" *ngIf="tab.adjType === 'Submitted'">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="align-left">
                          {{dataItem.status}}
                        </div>
                      </ng-template>
                      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                        let-filterService="filterService">
                        <kendo-grid-string-filter-menu [column]="column" [filter]="filter"
                          [filterService]="filterService" [extra]="false">
                          <kendo-filter-contains-operator></kendo-filter-contains-operator>
                        </kendo-grid-string-filter-menu>
                      </ng-template>
                    </kendo-grid-column>
                  </kendo-grid>
                </div>
              </ng-template>
            </kendo-tabstrip-tab>
          </kendo-tabstrip>
        </div>
      </div>
    </div>
  </div>
</div>
<app-notification-loading></app-notification-loading>

<!-- DELETE ADJUSTMENT RECORD -->
<kendo-dialog title="Delete Record" *ngIf="deleteReportDialog" (close)="deleteReportDialog=false" [minWidth]="250"
  id="delete-adj-dialog" class="app-dialog">
  <p>{{config.DeleteAdjReportMsg}}</p>
  <kendo-dialog-actions id="delete-adj-btns">
    <button kendoButton class="k-button" id="no-btn" [disabled]="loading" (click)="deleteReportDialog=false"
      primary="true">No</button>
    <button kendoButton class="k-button" id="yes-btn" [disabled]="loading" (click)="deleteAdjReport()" primary="true">
      <span *ngIf="!loading">Yes</span>
      <span *ngIf="loading" class="k-icon k-i-loading inner"></span>
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
